import { buttonBaseClasses, tabClasses, type Theme } from "@mui/material"
import { TabsTheme } from "core/themes/src/definitions/components.types"

export const createTabsTheme = (theme: Theme): TabsTheme => ({
    variants: [
        {
            props: { layout: "buttons" },
            style: {
                [`& .${buttonBaseClasses.root}.${tabClasses.root}`]: {
                    "&:hover": {
                        backgroundColor: theme.palette.grey[900],
                        color: theme.palette.getContrastText(theme.palette.grey[900]),
                    },
                },
            },
        },
    ],
    styleOverrides: {
        root: {
            minHeight: 0,
            [`& .${tabClasses.root}`]: {
                minWidth: 0,
                minHeight: 0,
                padding: "10px 10px 4px",
                borderBottom: "3px solid lightgray",
                background: "none",
                position: "relative",
                fontSize: theme.font.textSize.l,

                "&:hover": {
                    color: "#2e2e2e",
                },
            },
            [`& .${tabClasses.root}.${tabClasses.selected}`]: {
                color: "#2e2e2e",
            },
        },
    },
})
